export default __webpack_public_path__ + "static/media/closed-en.9ecfa933.png";